export default "__VITE_ASSET__ChwqdpTN__"